import React from 'react';
import { Box, Slider, Typography } from '@mui/material';

import HomeBottomButtonOptionsSettings from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsSettings';
import {
  NavigationModeType,
  NAVIGATION_MODES,
} from '@constants/navigationMode';
import LanguageSelector from '../LanguageSelector';

import { SettingsGeneralViewProps } from './interfaces';
import { useStyles } from './styles';
import { isDesktop } from 'react-device-detect';
import ReconnectExternalKeyboardButton from '@core/dashboard/components/Overlays/ExternalKeyboardOverlay/ReconnectExternalKeyboardButton';

const SettingsGeneralView = ({
  selectNavigationMode,
  selectedNavigationMode,
  translate,
  gameSound,
  handleChange,
  participantsSound,
  handleLoudness,
}: SettingsGeneralViewProps) => {
  const classes = useStyles();

  const navigationModes = NAVIGATION_MODES.map(({ id, labelKey }) => ({
    label: translate(labelKey),
    deviceId: id,
  }));

  return (
    <>
      <LanguageSelector
        label={translate('settingsModal.language')}
        sx={classes.buttonOptions}
      />
      <HomeBottomButtonOptionsSettings
        devices={navigationModes}
        handleSelect={(e) =>
          selectNavigationMode(e.target.value as NavigationModeType)
        }
        label={translate('settingsModal.navigationMode')}
        selectedValue={selectedNavigationMode}
        sx={classes.buttonOptions}
      />

      {/*<HomeBottomButtonOptionsSettings*/}
      {/*  devices={devices}*/}
      {/*  handleSelect={(e) => setStreamQuality(e.target.value)}*/}
      {/*  label={translate('settingsModal.quality')}*/}
      {/*  selectedValue={streamQuality}*/}
      {/*  SelectIcon={HighQualityIcon}*/}
      {/*/>*/}
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.worldSound')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={gameSound * 100}
          onChange={handleChange}
        />
      </Box>
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.loudness')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={participantsSound * 100}
          onChange={handleLoudness}
        />
      </Box>
      {!isDesktop && (
        <Box sx={classes.slider}>
          <ReconnectExternalKeyboardButton
            label={translate('settingsModal.reconnectExternalKeyboard')}
            fullWidth
            showReconnectedNotification
          />
        </Box>
      )}
    </>
  );
};

export default SettingsGeneralView;
